// extracted by mini-css-extract-plugin
export default {"statSection":"TaskStats_statSection__hKHIT","statContainer":"TaskStats_statContainer__aCgqt","stat":"TaskStats_stat__JWcmb"};